// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Zu1YN","select":"style_select__GzqMT","btn":"style_btn__Zt9Fk"};